import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
//   authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
//   projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
//   storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
//   messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
//   appId: process.env.REACT_APP_FIREBASE_APP_ID,
//   measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
// };
const firebaseConfig = {
  apiKey: "AIzaSyBqy2EupYPkRQWnA6knARQM_HhJsSkzhaU",
  authDomain: "coded-mind-inc.firebaseapp.com",
  projectId: "coded-mind-inc",
  storageBucket: "coded-mind-inc.firebasestorage.app",
  messagingSenderId: "749687380422",
  appId: "1:749687380422:web:1d57e1a5b9dcb1948ebac7",
  measurementId: "G-10E30R4QPQ"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);